"use strict";
/**
 * @module Session.notifications
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The type of topic notification that has been received.
 */
var TopicNotificationType;
(function (TopicNotificationType) {
    /**
     * The topic was added.
     */
    TopicNotificationType[TopicNotificationType["ADDED"] = 0] = "ADDED";
    /**
     * The topic existed at the time of the selector registration.
     */
    TopicNotificationType[TopicNotificationType["SELECTED"] = 1] = "SELECTED";
    /**
     * The topic was removed.
     */
    TopicNotificationType[TopicNotificationType["REMOVED"] = 2] = "REMOVED";
    /**
     * The topic was deselected.
     */
    TopicNotificationType[TopicNotificationType["DESELECTED"] = 3] = "DESELECTED";
})(TopicNotificationType = exports.TopicNotificationType || (exports.TopicNotificationType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/features/topic-notifications.js
// module id = 235
// module chunks = 1